import React from "react";
import { useRoutes } from "react-router-dom";
import AssistantsScreen from "../screens/AssistantsScreen/AssistantsScreen";
import AuthScreen from "../screens/AuthScreen/AuthScreen";
import DialogScreen from "../screens/DialogScreen/DialogScreen";
import IntegrationScreen from "../screens/IntegrationScreen/IntegrationScreen";
import RegisterScreen from "../screens/RegisterScreen/RegisterScreen";
import IntegrationTgBotScreen from "../screens/IntegrationTgBotScreen/IntegrationTgBotScreen";
import AssistantNewScreen from "../screens/AssistantNewScreen/AssistantNewScreen";
import ActiveTgBotScreen from "../screens/ActiveTgBotScreen/ActiveTgBotScreen";
import IntegrationWidgetScreen from "../screens/IntegrationWidgetScreen/IntegrationWidgetScreen";
import ActiveWidgetScreen from "../screens/ActiveWidgetScreen/ActiveWidgetScreen";
import ActiveTelegramScreen from "../screens/ActiveTelegramScreen/ActiveTelegramScreen";
import ActiveWhatsappScreen from "../screens/ActiveWhatsappScreen/ActiveWhatsappScreen";
import ActiveAvitoScreen from "../screens/ActiveAvitoScreen/ActiveAvitoScreen";
import { ActiveVkScreen } from "../screens/ActiveVkScreen/ActiveVkScreen";
import WalletScreen from "../screens/WalletScreen/WalletScreen";
import IntegrationDialogFormWidgetScreen from "../screens/IntegrationDialogFormWidgetScreen/IntegrationDialogFormWidgetScreen";
import ActiveDialogWFScreen from "../screens/ActiveDialogWFScreen/ActiveDialogWFScreen";
import ActiveBitrixScreen from "../screens/ActiveBitrixScreen/ActiveBitrixScreen";
import ActiveInstagramScreen from "../screens/ActiveInstagramScreen/ActiveInstagramScreen";
import ActiveBitrixChatBotScreen from "../screens/ActiveBitrixChatBotScreen/ActiveBitrixChatBotScreen";
import ActiveGoogleSheetsScreen from "../screens/ActiveGoogleSheetsScreen/ActiveGoogleSheetsScreen";
import { ActiveRentProgScreen } from "../screens/ActiveRentProgScreen/ActiveRentProgScreen";
import ActiveAmoScreen from "../screens/ActiveAmoScreen/ActiveAmoScreen";
import UserProfileScreen from "../screens/UserProfileScreen/UserProfileScreen";
import AssistantTestScreen from "../screens/AssistantTestScreen/AssistantTestScreen";

export default function AppRoutes() {
  const routes = useRoutes([
    {
      path: "/",
      element: <AuthScreen />,
      index: true,
    },
    {
      path: "register",
      element: <RegisterScreen />,
    },
    {
      path: "dialog",
      element: <DialogScreen />,
    },
    // {
    // 	path: 'bp',
    // 	children: [
    // 		// {
    // 		// 	element: <BpAddScreen />,
    // 		// 	index: true,
    // 		// },
    // 		{
    // 			element: <BpAddScreen />,
    // 			path: 'add',
    // 		},
    // 		{
    // 			path: 'list',
    // 			element: <BpListScreen />,
    // 			// skipLazyLoad: true,
    // 		},
    // 	],
    // },

    // {
    // 	path: 'synthesis',
    // 	element: <SynthesisDataScreen />,
    // },
    {
      path: "assistants",
      children: [
        {
          index: true,
          element: <AssistantsScreen />,
        },
        {
          path: "new",
          element: <AssistantNewScreen />,
        },
        {
          path: "update",
          element: <AssistantNewScreen />,
        },
        {
          path: ":id/test",
          element: <AssistantTestScreen />,
        },
      ],
    },
    {
      path: "/integration",
      children: [
        {
          index: true,
          element: <IntegrationScreen />,
        },
        {
          path: "telegram-bot",
          children: [
            {
              path: "active/:id",
              index: true,
              element: <ActiveTgBotScreen />,
            },
            { path: "new", element: <IntegrationTgBotScreen /> },
          ],
        },
        {
          path: "widget",
          children: [
            {
              path: "active/:id",
              index: true,
              element: <ActiveWidgetScreen />,
            },
            { path: "new", element: <IntegrationWidgetScreen /> },
          ],
        },
        {
          path: "dialog-form",
          children: [
            {
              path: "active/:id",
              index: true,
              element: <ActiveDialogWFScreen />,
            },
            {
              path: "new",
              element: <IntegrationDialogFormWidgetScreen />,
            },
          ],
        },
        {
          path: "telegram/:id",
          element: <ActiveTelegramScreen />,
        },
        {
          path: "whatsapp/:id",
          element: <ActiveWhatsappScreen />,
        },
        {
          path: "instagram/:id",
          element: <ActiveInstagramScreen />,
        },
        {
          path: "avito/:id",
          element: <ActiveAvitoScreen />,
        },
        {
          path: "vk/:id",
          element: <ActiveVkScreen />,
        },
        {
          path: "bitrix/:id",
          element: <ActiveBitrixScreen />,
        },
        {
          path: "bitrix-chat-bot/:id",
          element: <ActiveBitrixChatBotScreen />,
        },
        {
          path: "google-sheet/:id",
          element: <ActiveGoogleSheetsScreen />,
        },
        {
          path: "rent-prog/:id",
          element: <ActiveRentProgScreen />,
        },
        {
          path: "amo/:id",
          element: <ActiveAmoScreen />,
        },
      ],
    },
    {
      path: "/wallet",
      element: <WalletScreen />,
    },
    {
      path: "/profile",
      element: <UserProfileScreen />,
    },
    {
      path: "*",
      element: <AuthScreen />,
    },
  ]);
  return routes;
}
